import {PageService, PreviewService, MovieService} from 'hasta-la-vista-middleware-api/service'
import MetaData from  '../../../mixins/meta-data.js'

export default {
    mixins: [MetaData],
    data () {
        return {
            promo: {},
            movie: null,
            loading: true,
            dialogActive: false
        }
    },

    methods: {

        getAsyncData(){
            this.metaTitle = this.promo.title
            this.metaDescription = this.promo.strapline
            this.$emit('updateHead');
        },

        processPromo(promo){
            promo.srcsets = promo.mobile_image + ' 700w, ' + promo.image + ' 2000w'
            this.promo = promo
            this.loading = true;
            if (this.promo.related_movie) this.getMovie(this.promo.related_movie).then(()=>this.loading = false)
            else
                this.loading = false;
        },
        getContent() {
            this.loading = true;
            if (PreviewService.hasPreviewContent('promotion') && PreviewService.getPreviewContent().nid == this.$route.params.id) {
                this.processPromo(PreviewService.getPreviewContent('promotion'));


            } else
                PageService.getPromo().then((response)=> {
                    response.data.forEach((el)=> {
                        if (el.nid === this.$route.params.id) {
                            this.processPromo(el);
                        }
                    })
                    this.getAsyncData()

                })
        },

        getMovie(id) {


            return MovieService.getMovieDetail(id).then((response)=> {
                this.movie = response
            })
        }
    },

    created(){
        this.getContent()
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/promo/promo.js